module.exports = __webpack_public_path__ + "static/media/app-store.f87e5c39.svg";